<template>
	<div class="class-making-box clearfix">
		<h3 class="f-18 text-nomal">강의실 설정</h3>
		<div class="white-box clearfix">
			<p class="f-14">
				<img src="images/s-check2.png" alt="">
				강의실 설정
			</p>
			<!-- <div class="round m-b-10 on-border">
				<div class="input-group full-width">
					<span class="input-group-addon label not bg-blue v-mid text-white">
						온라인 강의
					</span>
					<div class="input-group-addon text-left p-l-10 p-5 bg-white">
						<input id="check1" class="checkbox2" type="checkbox" v-model="opts['동영상 등록']">
						<label for="check1">동영상 등록</label>
					</div>
				</div>
			</div> -->
			<div class="round m-b-10 on-border">
				<div class="input-group full-width">
					<span class="input-group-addon label not bg-blue v-mid text-white">
						시험 및 과제
					</span>
					<div class="input-group-addon text-left p-l-10 p-5 bg-white">
						<input id="check2" class="checkbox2" type="checkbox" v-model="opts['시험']">
						<label for="check2">시험</label>
					</div>
					<div class="input-group-addon text-left p-5 bg-white">
						<input id="check3" class="checkbox2" type="checkbox" v-model="opts['과제']">
						<label for="check3">과제</label>
					</div>
					<div class="input-group-addon text-left p-5 bg-white">
						<input id="check5" class="checkbox2" type="checkbox" v-model="opts['출결']">
						<label for="check5">출결</label>
					</div>
				</div>
			</div>
			<div class="round m-b-10 on-border">
				<div class="input-group full-width">
					<span class="input-group-addon label not bg-blue v-mid text-white">
						설문
					</span>
					<div class="input-group-addon text-left p-l-10 p-5 bg-white">
						<input id="check4" class="checkbox2" type="checkbox" v-model="opts['설문']">
						<label for="check4">설문</label>
					</div>
				</div>
			</div>
		</div>

		<!-- button wrapper -->
		<button class="btn bg-deepblue text-white round m-t-30 pull-right" type="button" @click="this.nextStep">저장하고 넘어가기</button>
	</div>
</template>

<script>
export default {
	name: "SubviewClassRegisterStep_1",
	data: function() {
		return {
			data: {
				classroomOpt: this.classData.classroomOpt,
			},
			opts: {
				"동영상 등록": this.classData.classroomOpt.indexOf("동영상 등록")!==-1,
				"시험": this.classData.classroomOpt.indexOf("시험")!==-1,
				"과제": this.classData.classroomOpt.indexOf("과제")!==-1,
				"출결": this.classData.classroomOpt.indexOf("출결")!==-1,
				"설문": this.classData.classroomOpt.indexOf("설문")!==-1
			}
		}
	},
	props: {
		classData: Object
	},
	methods: {
		toggleOpt: function(optName) {
			if(this.data.classroomOpt.index(optName)!==-1)
				this.data.classroomOpt = this.data.classroomOpt.replace(optName,'');
			else
				this.data.classroomOpt += optName;
		},
		nextStep: function() {
			for(let i=0; i<Object.keys(this.opts).length; i+=1)
				if(this.opts[Object.keys(this.opts)[i]])
					if(this.data.classroomOpt=="") {
						this.data.classroomOpt += Object.keys(this.opts)[i];
					} else {
						this.data.classroomOpt += ", "+Object.keys(this.opts)[i];
					}
			if(this.data.classroomOpt=="") {
				this.$emit("confirm", "강의실 설정을 완료하셨습니까?", ()=>{
					this.$emit("closeConfirm");
					this.$emit("nextStep", this.data);
				});
				return;
			}
			this.$emit("nextStep", this.data);
		}
	}
}
</script>

<style>

</style>